import UAParser from '@amplitude/ua-parser-js';

export function getUserDeviceInfo() {
  let parser = new UAParser();
  let result = parser.getResult();
  return result;
}
